const publicResources = {
  image: {
    downloadAppStore: `https://link.menur.app/menu/app_store_logo`,
    downloadGooglePlay: `https://link.menur.app/menu/google_play_logo`,
    emptyAssign: `https://link.menur.app/menu/empty_assign`,
    logoFull: `https://link.menur.app/menu/logo_full`,
    wavesBackground: `https://link.menur.app/menu/waves-background`,
  },
};

export { publicResources };
